import React from 'react';
import PropTypes from 'prop-types';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';

const BlockInfos = ({ product, productV2, strings, id }) => {
  const contentViewBlock = (
    <div className="content" key={id}>
      <div className="info" key={`info-${id}`}>
        {/* <ItemField
        label={strings['product.block.informations.field.code.label'] || 'Code'}
        value={product.code}
      /> */}
        <div className="group">
          <ItemField
            label={strings['product.block.informations.field.name.label'] || 'Name'}
            value={productV2.name}
            name="name"
            optional
          />
        </div>
        <div className="group">
          <ItemField
            label={strings['product.block.informations.field.description.label'] || 'Description'}
            value={product.description}
            name="description"
            optional
          />
        </div>
        {/* <div className="group">
        <ItemField
          label={strings['product.block.informations.field.start_date.label'] || 'Start Date'}
          value={product.start_date}
          name="start_date"
          optional
        />
        <ItemField
          label={strings['product.block.informations.field.end_date.label'] || 'End Date'}
          value={product.end_date}
          name="end_date"
          optional
        />
      </div> */}
      </div>
    </div>
  );

  return contentViewBlock;
};

BlockInfos.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  product: PropTypes.object,
  productV2: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockInfos.defaultProps = {
  product: {},
  productV2: {},
  strings: {},
};

const config = {
  title: 'product.block.informations.title',
  defaultTitle: 'Informations',
  name: 'informations',
  active: false,
};

export default withToggleView(BlockInfos, config);
